// extracted by mini-css-extract-plugin
export default {"loader":"CircularSpinner_loader__Qydm0","load8":"CircularSpinner_load8__7wqWX"};